<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ded"><b>Also in the Russian Trilogy Series</b></p>
<p class="ded1"><i>Conspiracy in Kiev</i></p>
<p class="ded1"><i>Midnight in Madrid</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c3.vue?3726413a